import React, { useState } from "react";
import { Autocomplete, useLoadScript } from "@react-google-maps/api";
import { IUsageGroupLocation } from "../../../repertoire/types/usageTypes/IUsageGroupLocation";
import { SOCAN_CUSTOMER_NAME } from "../../../home/Consts";

export interface IMapSearchProps {
    updateGoogleVenue: (venue: IUsageGroupLocation) => void;
    client?: string;
    viewData?: any;
}

function MapsSearch(props: IMapSearchProps) {
    const [searchResult, setSearchResult] = useState<any>("Result: none");
    const { client, viewData } = props;

    const { isLoaded } = useLoadScript({
        googleMapsApiKey: "AIzaSyCkf4i1fmMijSv08OdOlxggXQZRIHb0-oo",
        libraries: ["places"]
    });

    function onLoad(autocomplete) {
        setSearchResult(autocomplete);
    }


    let placeAddresCompoponent = {
        TOWN: 'postal_town',
        COUNTRY: 'country',
        REGION: 'administrative_area_level_1',
        LOCALITY: 'locality'
    }
    function getCityFromPlace(place): string {
        const addressComponents = place.address_components;
        const component = addressComponents.filter(aComp =>
            aComp.types.some(typesItem =>
                typesItem === placeAddresCompoponent.TOWN || typesItem === placeAddresCompoponent.LOCALITY
            )
        );
        return (component != null && component.length > 0) ? component[0].short_name : '';
    }

    function getAddressComponent(address_components, key) {
        var value = '';
        var postalCodeType = address_components.filter(aComp =>
            aComp.types.some(typesItem => typesItem === key))
        if (postalCodeType != null && postalCodeType.length > 0)
            value = postalCodeType[0].short_name
        return value;
    }

    function onPlaceChanged() {
        if (searchResult != null) {
            const { updateGoogleVenue } = props;
            const place = searchResult.getPlace();

            let venue: IUsageGroupLocation = {
                googleVenue: place.place_id,
                venue: place.name,
                country: getAddressComponent(place.address_components, placeAddresCompoponent.COUNTRY),
                city: getCityFromPlace(place),
                region: getAddressComponent(place.address_components, placeAddresCompoponent.REGION),
                addDetailsManually: false,
            }
            updateGoogleVenue(venue)
        } else {
            alert(viewData ? viewData['pleaseEnterText'] : "Please enter text");
        }
    }

    if (!isLoaded) {
        return <div>Loading...</div>;
    }

    return (
        <div className="App">
            <div id="searchColumn">
                <Autocomplete onPlaceChanged={onPlaceChanged} onLoad={onLoad}>
                    <input className="mapSearch"
                        type="text"
                        placeholder={viewData ? viewData['searchForVenue'] : "Search for Venue"}
                    />
                </Autocomplete>
            </div>
        </div>
    );
}

export default MapsSearch;
